import ErrorIcon from '@mui/icons-material/Error';
export const InvalidInputMessage = ({ errorMessage }) => {
  if (!errorMessage) return null;
  return (
    <div className="w-full mt-3 text-base text-white font-body-primary text-center">
      <ErrorIcon className="text-chilli inline-block mr-1" />
      {errorMessage}
    </div>
  );
};
